import { render, staticRenderFns } from "./VariableRecords.vue?vue&type=template&id=3a76f0d4"
import script from "./VariableRecords.vue?vue&type=script&lang=js"
export * from "./VariableRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports